import { FC } from 'react';
import { Card, CardHeader, IconButton, Stack } from '@mui/material';
import { alpha } from '@mui/material/styles';
import {
  Close as CloseIcon,
  DragIndicator as DragIndicatorIcon,
  Edit as EditIcon,
} from '@mui/icons-material';

export interface QuestionItemCardProps {
  /** Item display name */
  title?: string;
  /** Subheader / description text */
  description?: string;
  /** Optional image shown in the avatar — currently unused */
  imageUrl?: string;
  /** MUI palette path — currently unused */
  accentColor?: string;
  /** When provided, shows an Edit icon button */
  onEdit?: () => void;
  /** When provided, shows a Remove (×) icon button */
  onRemove?: () => void;
}

/**
 * Shared catalog-item card used to display cuts, trims, specs, and extras
 * consistently across all question types.
 * @param root0
 * @param root0.title
 * @param root0.description
 * @param root0.imageUrl
 * @param root0.accentColor
 * @param root0.onEdit
 * @param root0.onRemove
 */
export const QuestionItemCard: FC<QuestionItemCardProps> = ({
  title,
  description: _description,
  imageUrl: _imageUrl,
  accentColor: _accentColor,
  onEdit,
  onRemove,
}) => (
  <Card
    variant="outlined"
    sx={{
      backgroundColor: (theme) => alpha(theme.palette.background.paper, 0.7),
    }}
  >
    <CardHeader
      avatar={
        <DragIndicatorIcon fontSize="small" sx={{ color: 'text.disabled' }} />
      }
      action={
        onEdit || onRemove ? (
          <Stack direction="row" spacing={0.5} alignItems="center">
            {onEdit && (
              <IconButton size="small" onClick={onEdit}>
                <EditIcon fontSize="small" />
              </IconButton>
            )}
            {onRemove && (
              <IconButton size="small" onClick={onRemove}>
                <CloseIcon fontSize="small" />
              </IconButton>
            )}
          </Stack>
        ) : undefined
      }
      title={title || 'Unnamed'}
      slotProps={{
        title: { variant: 'body2', fontWeight: 'medium' },
        action: { sx: { alignSelf: 'center' } },
        avatar: { sx: { alignSelf: 'center' } },
      }}
    />
  </Card>
);
